import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import { HelmetProvider } from "react-helmet-async";

const theme = createTheme({
  palette: {
    primary: {
      main: "#E21608",
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <MuiThemeProvider theme={theme}>
        <App />
      </MuiThemeProvider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
